import { Controller } from '@hotwired/stimulus';

// Scroll-Spy für die Fragen-Navigation der Pflegegrade-Pillar-Seiten.
// Markiert das Kapitel an der Lesekante in Rail (Desktop) und Chip-Leiste
// (mobil) per data-active; Sprünge scrollen sanft, sofern keine reduzierte
// Bewegung gewünscht ist.
export default class extends Controller {
    static targets = ['link'];

    connect() {
        this.sections = this.linkTargets
            .map((link) => document.getElementById(this.anchorId(link)))
            .filter(Boolean);
        this.activeId = null;
        this.ticking = false;
        this.onScroll = () => this.requestUpdate();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.requestUpdate();
    }

    disconnect() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
    }

    jump(event) {
        const section = document.getElementById(this.anchorId(event.currentTarget));
        if (!section) return;
        event.preventDefault();
        section.scrollIntoView({ behavior: this.reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', `#${section.id}`);
    }

    requestUpdate() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
            this.ticking = false;
            this.update();
        });
    }

    update() {
        // Aktiv ist das letzte Kapitel, dessen Oberkante die Lesekante passiert
        // hat; am Seitenende gewinnt das letzte Kapitel.
        const readingEdge = window.innerHeight * 0.25;
        const atBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 4;
        let current = this.sections[0];
        for (const section of this.sections) {
            if (section.getBoundingClientRect().top <= readingEdge) current = section;
        }
        if (atBottom) current = this.sections[this.sections.length - 1];
        if (!current || current.id === this.activeId) return;
        this.activeId = current.id;

        this.linkTargets.forEach((link) => {
            const active = this.anchorId(link) === current.id;
            link.toggleAttribute('data-active', active);
            if (active) {
                link.setAttribute('aria-current', 'location');
            } else {
                link.removeAttribute('aria-current');
            }
            // Aktiven Chip in der Leiste zentrieren: nur die Leiste scrollen, nie das
            // Fenster (scrollIntoView zog die Seite zur Leiste, wenn die außerhalb lag)
            if (active && 'chip' in link.dataset) {
                const bar = link.parentElement;
                const offset = link.getBoundingClientRect().left - bar.getBoundingClientRect().left + bar.scrollLeft;
                bar.scrollTo({
                    left: offset - (bar.clientWidth - link.offsetWidth) / 2,
                    behavior: this.reducedMotion() ? 'auto' : 'smooth',
                });
            }
        });
    }

    anchorId(link) {
        return (link.getAttribute('href') || '').split('#')[1];
    }

    reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
}
